module.exports = __webpack_public_path__ + "img/pati-logo.e0f0bc41.png";